/**
 * 
 * @param parentNode string the parent tag/class/id you are looking for
 * @param node any html event target e.i event.target
 * @param type string tag/id/class
 */

export default (parentNode, node, type) => {
  let obj = node.parentNode;
  
  if (type === 'tag' || type == null) {
    try {
      while (obj.tagName !== parentNode) {
        obj = obj.parentNode;
      }
    } catch(e) {
      return null
    }
  }
  
  else if (type === 'id') {
    try {
      while (obj && obj.id !== parentNode) {
        obj = obj.parentNode;
      }
    } catch(e) {
      return null;
    }
  }

  else if (type === 'class') {
    try {
      while (obj.classList.contains(parentNode) === false) {
        obj = obj.parentNode;
      }
    } catch(e) {
      return null;
    }
  }

  return obj;
}